import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-black border-solid"></div>

    </div>
  );
};

export default LoadingSpinner;
